export default "__VITE_ASSET__B0GaoY_e__"